<template>
  <div
    class="business-item"
    :class="{ 'current-path-direct-access': sameRouteAsCurrent(item.path), 'hover-item': hover && !sameRouteAsCurrent(item.path), 'cursor-pointer': item.path }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="(!sameRouteAsCurrent(item.path) && item.path) ? $router.push(item.path) : ''"
  >
    <div class="d-flex align-items-center justify-content-between">
      <b-media no-body>
        <b-media-aside class="mr-75">
          <feather-icon
            class="align-text-bottom"
            size="20"
            :icon="item.icon"
          />
        </b-media-aside>
        <b-media-body class="my-auto">
          <h6 class="mb-0">
            {{ item.title }}
          </h6>
          <small>{{ item.description }}</small>
        </b-media-body>
      </b-media>
    </div>
    <transition name="slide-fade">
      <div v-if="hover && item['sub-items']">
        <div class="divider my-2">
          <div class="divider-text">
            Contenido
          </div>
        </div>

        <div
          v-for="(subitem, index) in item['sub-items']"
          :key="`sub-${index}`"
          class="business-item d-flex align-items-center justify-content-between"
          :class="{ 'current-path-direct-access': sameRouteAsCurrent(subitem.path), 'hover-sub-item': !sameRouteAsCurrent(subitem.path), 'cursor-pointer': subitem.path }"
          @click="(!sameRouteAsCurrent(subitem.path) && subitem.path) ? $router.push(subitem.path) : ''"
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <feather-icon
                class="align-text-bottom"
                size="20"
                :icon="subitem.icon"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ subitem.title }}
              </h6>
              <small>{{ subitem.description }}</small>
            </b-media-body>
          </b-media>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  BMedia,
  BMediaAside,
  BMediaBody,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'

export default {
  components: {
    BMedia,
    BMediaAside,
    BMediaBody,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const { route } = useRouter()
    const hover = ref(false)
    const sameRouteAsCurrent = path => path === route.value.path

    return {
      hover,
      sameRouteAsCurrent,
    }
  },
}
</script>

<style scoped>
  .current-path-direct-access {
    cursor: default !important;
    background-color: #008645 !important;
    color: white !important;
  }

  .current-path-direct-access h6 {
    color: white !important;
  }

  .hover-item {
    background-color: #f8f8f8;
    color: #4b4b4b;
  }

  .hover-item h6 {
    color: #4b4b4b;
  }

  .hover-sub-item:hover {
    background-color: #e2e2e2;
  }
</style>
